// extracted by mini-css-extract-plugin
module.exports = {"information":"About_information__24so6","iconLink":"About_iconLink__1fcsZ","informationDetails":"About_informationDetails__1ibf5","text":"About_text__1GVj6"};